module.exports = __webpack_public_path__ + "static/media/1841.ce5e3276.jpg";